"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.initialState = void 0;

var _reactVirtualized = require("react-virtualized");

var ACTION_TYPES = _interopRequireWildcard(require("../actionTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  oeProducts: [],
  sortBy: "partTerminologyName",
  sortDirection: _reactVirtualized.SortDirection.ASC,
  research: {
    partTerminologyID: "",
    partTerminologyName: "",
    categoryName: [],
    subCategoryName: [],
    region: [],
    availability: [],
    oeCategory: []
  },
  filters: {
    partTerminologyID: [],
    partTerminologyName: [],
    categoryName: [],
    subCategoryName: [],
    region: [],
    availability: [],
    oeCategory: []
  },
  selectedItems: [],
  externalInfo: new Map(),
  showOEProductOnly: true
};
exports.initialState = initialState;

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ACTION_TYPES.SET_OE_PRODUCTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        oeProducts: action.payload
      });

    case ACTION_TYPES.SET_SORT_OPTIONS:
      return resolveSort(state, action.payload);

    case ACTION_TYPES.SET_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: action.payload
      });

    case ACTION_TYPES.SET_SELECTED_ITEMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedItems: action.payload
      });

    case ACTION_TYPES.SET_SELECTED_ITEMS_AND_EXTERNAL_INFO:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedItems: action.payload.selectedItems,
        externalInfo: action.payload.externalInfo
      });

    case ACTION_TYPES.SET_SHOW_OE_PRODUCTS_ONLY:
      return _objectSpread(_objectSpread({}, state), {}, {
        showOEProductOnly: action.payload
      });

    case ACTION_TYPES.SET_PART_TERMINOLOGY_ID_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: _objectSpread(_objectSpread({}, state.research), {}, {
          partTerminologyID: action.payload
        })
      });

    case ACTION_TYPES.SET_PART_TERMINOLOGY_NAME_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: _objectSpread(_objectSpread({}, state.research), {}, {
          partTerminologyName: action.payload
        })
      });

    case ACTION_TYPES.SET_CATEGORY_NAME_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: _objectSpread(_objectSpread({}, state.research), {}, {
          categoryName: action.payload
        })
      });

    case ACTION_TYPES.SET_SUBCATEGORY_NAME_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: _objectSpread(_objectSpread({}, state.research), {}, {
          subCategoryName: action.payload
        })
      });

    case ACTION_TYPES.SET_REGION_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: _objectSpread(_objectSpread({}, state.research), {}, {
          region: action.payload
        })
      });

    case ACTION_TYPES.SET_AVAILABILITY_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: _objectSpread(_objectSpread({}, state.research), {}, {
          availability: action.payload
        })
      });

    case ACTION_TYPES.SET_OE_CATEGORY_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: _objectSpread(_objectSpread({}, state.research), {}, {
          oeCategory: action.payload
        })
      });

    case ACTION_TYPES.RESET_RESEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        research: initialState.research
      });

    case ACTION_TYPES.SET_FILTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: action.payload
      });

    default:
      return state;
  }

  ;
};

exports.reducer = reducer;

var resolveSort = function resolveSort(state, payload) {
  var previousSortBy = state.sortBy;
  var previousSortDirection = state.sortDirection;
  var newSortDirection = previousSortBy === payload ? previousSortDirection === _reactVirtualized.SortDirection.ASC ? _reactVirtualized.SortDirection.DESC : _reactVirtualized.SortDirection.ASC : _reactVirtualized.SortDirection.ASC;
  return _objectSpread(_objectSpread({}, state), {}, {
    sortBy: payload,
    sortDirection: newSortDirection
  });
};